export const list1 = [
  'A guide to creating your first prototype'
]
export const list2 = [
    'How to link screens with hotspots',
    'How to make a copy of your designs',
    'How to play your prototype in desktop, tablet and mobile browsers',
    'How do I duplicate a hotspot?',
    'How do I replace or update a screen in my prototype?',
    'How to use transitions',
    'How to add designs to your prototype',
    'How to wireframe and design in HostDesign'
]
export const list3 = [
    'How to use sections How to keep the positioning of the page scroll when moving to a new ',
    'How to make a copy of your designs',
    'How to delete a section',
    'How do I duplicate a hotspot?',
    'How to manually enter or view the size and X/Y coordinates of your hotspot is that awesome',
    'How to rename a section',
    'How to collapse a section',
    'How to move a section to another position',
    'How your clients and stakeholders can open prototypes in the Hostdesign iOS app without an',
    'How to move images between sections'
]

export const list4 = [
    'How to change the prototype device to website, iPhone, Apple Watch, iPad or Android',
    'How to change the background colour of your prototypes to match your designs',
    'How to disable resizing designs when the browser changes size',
    'How to hide hotspot hints when playing prototypes',
    'How to scale down retina images for non-retina desktop devices',
    'How do I add an app icon to my mobile prototype?',
    'Screen Resolutions'
]

export const list5 =[
    'How to embed YouTube, Vimeo or Wistia videos',
    'How to link a hotspot to an external URL or email address',
    'How to embed a Spotify or Soundcloud track into your prototype',
    'How to keep the positioning of the page scroll when moving to a new screen',
    'How to move between screens automatically with timers',
    'Create dynamic hotspot templates using Sketch',
    'Creating a fixed header and footer',
    'How to use Keep Scroll Position',
    'How do I link or anchor to an area on the same page?',
    'How to use animated GIFs in your prototypes',
    'How do I automatically link to the previous screen the user visited?',
    'How to manually enter or view the size and X/Y coordinates of your hotspot',
    'How to use containers to create carousels, fixed sidebars and elements',
    'Layers - Add modals and sidebar menus',
    'How to embed maps from Google Maps or Mapbox'
];

export const list6 =[
    'How to download your prototype offline (ZIP)',
    'How to download your prototype as a PDF document',
    'How to view your prototype on the Hostdesign iOS app',
    'How to view your prototype on the Hostdesign Android app',
    'How your clients and stakeholders can open prototypes in the Marvel iOS app without an ',
    'How to share the link to your prototype via SMS or Email',
    'How to embed your prototype on Wordpress (or any web page, blog or portfolio)'
]

export const list7 = [
    'How to download your prototype offline (ZIP)',
    'How to download your prototype as a PDF document',
    'How to view your prototype on the Hostdesign iOS app',
    'How to view your prototype on the Hostdesign Android app',
    'How your clients and stakeholders can open prototypes in the Marvel iOS app without an '
]

export const articles1 = [
    'How to play your prototype in desktop, tablet and mobile browsers',
    'How to make a copy of your designs',
    'How do I duplicate a hotspot?',
    'How to use transitions',
    'How to embed a Spotify or Soundcloud track into your prototype',
    'Create dynamic hotspot templates using Sketch'
]

export const articles2 = [
    'How to keep the positioning of the page scroll when moving to a new screen',
    'How to play your prototype in desktop, tablet and mobile browsers',
    'How do I replace or update a screen in my prototype?',
    'How to add designs to your prototype',
    'How to move between screens automatically with timers',
    'Creating a fixed header and footer'
]